import { render, staticRenderFns } from "./RecurrenceMonthInput.vue?vue&type=template&id=10df39d5&"
import script from "./RecurrenceMonthInput.vue?vue&type=script&lang=ts&"
export * from "./RecurrenceMonthInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
